/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
// import * as Msdyn365 from '@msdyn365-commerce/core';
// import { getUrlSync } from '@msdyn365-commerce/core';
import {
    Button
    // getPayloadObject,
    // getTelemetryAttributes,
    // ITelemetryContent
    // onTelemetryClick,
    // UncontrolledTooltip
} from '@msdyn365-commerce-modules/utilities';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface ILanguageSelectorProps {}

/**
 *
 * LanguageSelector component.
 * @extends {React.PureComponent<ILanguageSelectorProps>}
 */

@observer
export class LanguageSelector extends React.PureComponent<ILanguageSelectorProps> {
    constructor(props: ILanguageSelectorProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <>
                <Button
                    className='ms-language-selector'
                    // href={url}
                    // onClick={onTelemetryClick(this.props.telemetryContent!, payLoad, this.props.wishlistTooltipText)}
                >
                    <span className='ms-wishlist-text-new'>Arabic</span>
                </Button>
            </>
        );
    }
}
